export default __webpack_public_path__ + "static/media/chartaccounts.c544404d.svg";